import { ValidationUtil } from '../module/util/validation/validation.util';


interface VeeValidateExtend {
    name: string;
    properties: VeeValidateExtendProperties;
}

interface VeeValidateExtendProperties {
    getMessage: any;
    validate: any;
}

export const VALIDATE_CONSTANT: Array<VeeValidateExtend> = [
    {
        name: 'cpf',
        properties: {
            getMessage: () => {
                return 'CPF is inválid';
            },
            validate: (value: string) => {
                return ValidationUtil.validCPF(value || '');
            }
        }
    },
    {
        name: 'birthday_elder',
        properties: {
            getMessage: () => {
                return 'Date inválid for an elder';
            },
            validate: (value: string, args: Array<any>) => {
                return ValidationUtil.validBirthDayElder(value || '', args[0].in_format);
            }
        }
    },
    {
        name: 'time',
        properties: {
            getMessage: () => {
                return 'Formato inválido';
            },
            validate: (value: string) => {
                return ValidationUtil.validTime(value || '');
            }
        }
    }
];